export default function isEmpty(element) {
    if (Array.isArray(element))
        return element.length <= 0;
    else if (typeof element === 'object' &&
    !Array.isArray(element) && element !== null)
        return Object.keys(element).length <= 0;
    else
        return true;
}